import React from 'react'
import {Link} from 'react-router-dom'

function Logo(){

    return(
        <div className="logo">
            <Link to='/'><img src="/oitid/student/assets/images/logo_main.svg" alt="OITID STUDENT EDITION" /></Link>
        </div>
    )
    
}

export default Logo